import { NgClass } from '@angular/common';
import { Component, effect, OnDestroy, OnInit } from '@angular/core';
import { IonTabBar, IonTabButton, IonTabs } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { CurrentPlatformService } from '@services/current-platform.service';
import { Subscription } from 'rxjs';
import { Preferences } from '@capacitor/preferences';
import { ActivatedRoute, Router } from '@angular/router';
import { getDataFromRoute } from '@shared/utils/get-data-from-route';
import { IconComponent } from '@shared/svg-icon/svg-icon.component';

@Component({
  selector: 'app-global-navigation',
  templateUrl: 'global.navigation.html',
  imports: [IonTabs, IonTabButton, IonTabBar, NgClass, TranslateModule, IconComponent],
})
export class GlobalNavigationComponent implements OnInit, OnDestroy {
  platformReady: boolean = false;
  currentPlatform: string = '';
  isPrime!: boolean;
  tabs = [
    { tab: 'home', label: 'home.home', icon: 'home', nonPrimeIcon: 'home-non-prime', primeIcon: 'home-prime' },
    { tab: 'get-care', label: 'home.getCare', icon: 'care', nonPrimeIcon: 'care-non-prime', primeIcon: 'care-prime' },
    {
      tab: 'location',
      label: 'home.locations',
      icon: 'location',
      nonPrimeIcon: 'location-non-prime',
      primeIcon: 'location-prime',
    },
    { tab: 'account', label: 'home.me', icon: 'user', nonPrimeIcon: 'user-non-prime', primeIcon: 'user-prime' },
  ];
  showTabBar: boolean = true;
  subscription: Subscription = new Subscription();
  isLoading: boolean = false;

  constructor(
    private readonly authService: AuthService,
    private readonly platform: CurrentPlatformService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    effect(() => {
      this.isPrime = this.authService.isPrime();
    });
  }

  async ngOnInit(): Promise<void> {
    this.platformReady = await this.platform.isPlatformReady();
    this.currentPlatform = this.platform.getCurrentPlatform();
    await Preferences.remove({ key: 'REDIRECT_LOCATION' });

    this.subscription = getDataFromRoute(this.router, this.activatedRoute).subscribe(
      (data) => (this.showTabBar = data.shouldShowTabBar ?? true),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  async onTabChange(): Promise<void> {
    this.isLoading = true;
  }

  async onTabChanged(): Promise<void> {
    setTimeout(() => {
      this.isLoading = false;
    }, 200);
  }

  isTabActive(tabName: string): boolean {
    const currentUrl = this.router.url;
    // Handle root path case
    if (tabName === 'home' && currentUrl === '/') {
      return true;
    }
    // Check if current URL starts with the tab name
    return currentUrl.startsWith(`/${tabName}`);
  }
}
